const ja = {
  common: {
    appName: '世論監視システム',
    loading: '読み込み中...',
    noData: 'データなし',
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    edit: '編集',
    delete: '削除',
    add: '追加',
    search: '検索',
    export: 'エクスポート',
    back: '戻る',
    next: '次へ',
    prev: '前へ',
    submit: '送信',
    reset: 'リセット',
    close: '閉じる',
    all: 'すべて',
    total: '合計',
    actions: '操作',
    status: 'ステータス',
    type: 'タイプ',
    name: '名称',
    time: '時間',
    operation: '操作',
    success: '成功',
    failed: '失敗',
    yes: 'はい',
    no: 'いいえ',
    page: 'ページ',
    of: '/',
    items: '件',
    selectPlaceholder: '選択してください',
    inputPlaceholder: '入力してください',
    viewOriginal: '原文を見る',
  },
  nav: {
    dashboard: 'ダッシュボード',
    monitor: '監視管理',
    monitorManage: '監視管理',
    monitorData: 'データ監視',
    analysis: '監視分析',
    volume: 'ボリューム監視',
    publicOption: 'イベント分析',
    report: '分析レポート',
    settings: 'システム設定',
    settingsWarning: '警告設定',
    settingsWarningMsg: '警告メッセージ',
    settingsPreference: '基本設定',
    settingsFeedback: 'フィードバック',
  },
  login: {
    title: 'サインイン',
    subtitle: '世論監視システム',
    phone: '電話番号',
    phonePlaceholder: '電話番号を入力してください',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力してください',
    signIn: 'サインイン',
    signingIn: 'サインイン中...',
    logout: 'サインアウト',
    invalidCredentials: '電話番号またはパスワードが正しくありません',
  },
  dashboard: {
    title: 'ダッシュボード',
    todayStatus: '今日の世論状況',
    warningAlerts: '警告世論',
    hotEvents: '話題のイベント',
    hotSearch: '人気検索キーワード',
    leadersOpinion: '指導者の世論',
    pushOpinion: 'プッシュ世論',
    reprintQuery: '転載クエリ',
    collection: '収藏投稿',
    hotWeibo: 'Weiboトレンド',
    hotWechat: 'WeChatトレンド',
    hotDouyin: 'Douyinトレンド',
    hotBilibili: 'Bilibiliトレンド',
    onlineUsers: 'オンラインユーザー',
    dailyReport: '日報',
    weeklyReport: '週報',
  },
  monitor: {
    title: '監視管理',
    addGroup: 'グループ追加',
    editGroup: 'グループ編集',
    deleteGroup: 'グループ削除',
    addProject: 'プロジェクト追加',
    editProject: 'プロジェクト編集',
    deleteProject: 'プロジェクト削除',
    groupName: 'グループ名',
    projectName: 'プロジェクト名',
    projectType: 'プロジェクトタイプ',
    normal: '通常',
    advanced: '高度',
    subjectWord: 'メインキーワード',
    characterWord: '人物キーワード',
    eventWord: 'イベントキーワード',
    regionalWord: '地域キーワード',
    stopWord: '除外キーワード',
    projectDescription: 'プロジェクトの説明',
    selectProject: 'モニタ管理ページからプロジェクトを選択してください',
    deleteConfirm: '本当に削除しますか？',
    groupDeleteConfirm: 'このグループを削除すると、グループ内のすべてのプロジェクトも削除されます。続行しますか？',
    dataList: 'データ監視',
    articleTitle: '記事タイトル',
    sourceName: 'ソース',
    publishTime: '公開時間',
    emotion: '感情',
    positive: 'ポジティブ',
    neutral: 'ニュートラル',
    negative: 'ネガティブ',
    similarCount: '類似数',
    sourcePlatform: 'ソースプラットフォーム',
    keyword: 'キーワード',
    timeRange: '期間',
    hours24: '24時間',
    today: '今日',
    yesterday: '昨日',
    days3: '3日間',
    days7: '7日間',
    days15: '15日間',
    days30: '30日間',
    days365: '1年',
    custom: 'カスタム',
    emotionFilter: '感情フィルター',
    sourceFilter: 'ソースフィルター',
    sortBy: '並び替え',
    timeDesc: '時間降順',
    timeAsc: '時間昇順',
    similarDesc: '類似数降順',
    matchMode: 'マッチング方式',
    fullText: '全文',
    titleOnly: 'タイトルのみ',
    contentOnly: '本文のみ',
    preciseFilter: '精密フィルター',
    mergeSimilar: '類似統合',
    sourcePlatforms: '監視ソースプラットフォーム',
    sourcePlatformsHint: '監視するプラットフォームを選択',
    platformsCount: 'プラットフォーム',
    projectPlatforms: 'プロジェクトプラットフォーム',
    sourcePlatformFilter: 'ソースプラットフォーム',
  },
  analysis: {
    title: '監視分析',
    dataOverview: 'データ概览',
    emotionalProportion: '感情割合',
    planWordHit: 'メインキーワード一致',
    keywordEmotionTrend: 'キーワード感情推移',
    hotEventRanking: '話題イベントランキング',
    highwordCloud: 'キーワードクラウド',
    keywordIndex: '高頻度語指数',
    mediaActivity: 'メディア活動度分析',
    hotSpotRanking: 'ホットスポットランキング',
    dataSourceDistribution: 'データソース分布',
    dataSourceAnalysis: 'データソース分析',
    keywordExposureRank: 'キーワード露出度ランキング',
    selfmediaVolumeRank: 'セルフメディアボリュームランキング',
    popularInformation: '人気情報',
    popularEvent: '話題イベント',
    hotCompany: '話題の企業',
    hotPeople: '話題の人物',
    hotSpot: '話題の地域',
    relativeNews: '関連ニュース',
    categoryRank: 'カテゴリー推移',
    industrialDistribution: '業界分布',
    eventStatistics: 'イベント統計',
    keywordEmotionStatistical: 'キーワード感情統計分布',
    timePeriod: '期間',
    update: '分析を更新',
    totalArticles: '総記事数',
    newsCount: 'ニュース数',
    socialCount: 'SNS数',
  },
  volume: {
    title: 'ボリューム監視',
    totalVolume: '総ボリューム',
    newsVolume: 'ニュースボリューム',
    socialVolume: 'ソーシャルボリューム',
    keywordEmotionStatistical: 'キーワード感情統計分布',
    keywordSourceDistribution: 'キーワードソース分布',
    keywordNewsRank: 'キーワードニュースランキング',
    topicClusterAnalysis: 'トピッククラスタリング分析',
    keywordEmotionTrend: 'キーワード感情推移',
    highwordCloud: 'キーワードクラウド',
    keywordExposureRank: 'キーワード露出度ランキング',
    keywordCorrelationNews: '話題コンテンツクラスタリングランキング',
    userPortraitLabel: 'ユーザーペルソナラベル',
    socialUserVolumeRank: 'SNSユーザーボリュームランキング',
    mediaUserVolumeRank: 'セルフメディアユーザーボリュームランキング',
  },
  publicOption: {
    title: 'イベント分析',
    addEvent: 'イベント作成',
    editEvent: 'イベント編集',
    deleteEvent: 'イベント削除',
    eventName: 'タスク名',
    eventKeywords: 'タスクキーワード',
    eventStartTime: '開始時間',
    eventEndTime: '終了時間',
    eventStopWords: '除外キーワード',
    reportList: 'レポートリスト',
    reportDetail: '分析詳細',
    backAnalysis: '溯源分析',
    eventContext: 'イベント脈絡',
    eventTrace: 'イベント追跡',
    hotAnalysis: 'ホット分析',
    netizensAnalysis: '主要ネットユーザー分析',
    statistics: '統計',
    propagationAnalysis: '伝播分析',
    thematicAnalysis: 'テーマ分析',
    unscrambleContent: 'コンテンツ解読',
    judicialOpinion: '司法世論分析研判',
    statusCreating: '作成中',
    statusFailed: '作成失敗',
    statusSuccess: '作成成功',
  },
  report: {
    title: '分析レポート',
    dailyReport: '日報',
    weeklyReport: '週報',
    monthlyReport: '月報',
    reportName: 'レポート名',
    reportType: 'レポートタイプ',
    reportPeriod: 'レポート期間',
    reportStatus: 'レポートステータス',
    generating: 'タスク生成済み',
    editing: '編集中',
    completed: '編集完了',
    failed: '編集失敗',
    deleteSelected: '一括削除',
    compile: '編集',
    viewDetail: '詳細表示',
    dataOverview: 'データ概览',
    emotionAnalysis: '感情分析',
    hotEventRanking: '話題イベントランキング',
    mediaActivity: 'メディア活動度分析',
    selfMediaRanking: 'セルフメディアランキング',
    highWordIndex: '高頻度語指数',
    hotSpotRanking: 'ホットスポットランキング',
    netizenWordCloud: 'ネットユーザー word cloud',
    mediaWordCloud: 'メディア word cloud',
    hotPeople: '話題の人物',
    hotSpots: '話題の地域',
    topicClustering: 'トピッククラスタリング分析',
    socialVRanking: 'SNSインフルエンサーランキング',
  },
  settings: {
    title: 'システム設定',
    warning: {
      title: '警告設定',
      warningName: '警告名',
      warningWord: '警告キーワード',
      warningSwitch: '警告スイッチ',
      warningClassify: 'ソースタイプ',
      warningContent: '警告内容',
      allContent: 'すべて',
      sensitiveOnly: '機密のみ',
      warningMatch: 'マッチング方式',
      warningDeduplication: '警告重複排除',
      warningSource: '警告ソース',
      systemPush: 'システムプッシュ',
      emailPush: 'メールプッシュ',
      receiveTime: '受信時間',
      weekendWarning: '週末警告',
      warningInterval: '警告間隔',
      realtime: 'リアルタイム',
      scheduled: 'スケジュール',
      messageList: '警告メッセージ',
      edit: '警告編集',
    },
    preference: {
      title: '基本設定',
      timeRange: '期間',
      preciseFilter: '精密フィルター',
      emotion: '感情属性',
      similar: '類似記事',
      sort: '情報ソート',
      matchMode: 'マッチング方式',
      dataSource: 'データソース',
      websiteName: 'ウェブサイト名',
      author: '著者名',
      organization: '関連機関',
      categoryLabel: '記事カテゴリー',
      enterpriseType: '関連企業',
      highTechType: 'ハイテク企業',
      policyLabel: '関連政策',
      dataSourceType: 'データカテゴリー',
      eventIndex: '関連イベント',
      industryIndex: '関連業界',
      province: '関連省',
      city: '関連都市',
    },
    feedback: {
      title: 'フィードバック・提案',
      content: 'フィードバック内容',
      submit: 'フィードバック送信',
    },
  },
}

export default ja
